<template>
  <v-app>
    <v-app-bar app elevation="0" color="white" fixed>
      <img class="ml-2" src="/img/samk_logo.svg" style="width: 80px;" alt="SAMK" />
      <img class="ml-2" src="/img/tassu800x800.png" style="width: 50px;" alt="TASSU" />
      <v-spacer></v-spacer>
      <v-btn-toggle :value="$i18n.locale" @change="changeLanguage" mandatory dense group class="mr-2">
        <v-btn v-for="lang in languages" :key="lang" :value="lang" small text>
          {{ lang.toUpperCase() }}
        </v-btn>
      </v-btn-toggle>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import {SUPPORTED_LANGUAGES, setLanguage} from '@/plugins/i18n';

export default {
  name: 'App',
  data: () => ({
    languages: SUPPORTED_LANGUAGES,
  }),
  methods: {
    changeLanguage(lang) {
      setLanguage(lang);
    },
  },
  mounted() {
 }
};
</script>

<style lang="scss">
@import "./sass/commonstyles.scss";
</style>